import gql from "graphql-tag";

export const MY_TIME_GET_RECORDING_PERIOD = gql`
  query getRecordingPeriod {
    getRecordingPeriod {
      year
      month
    }
  }
`;
